import React from 'react'
import HomeHero from '../../components/home/HomeHero'
import './Home.css'
import About from '../../components/about/About'
import Ready from '../../components/home/Ready'
import Footer from '../../components/footer/Footer'
import Footer2 from '../../components/footer/Footer2'

function Home() {
    return (
        <div className="main">
            <HomeHero/>
            <About
                aboutTitle1="Lideramos proyectos digitales con equipos multidisciplinares."
                aboutContent1="Un proyecto con nosotros implica dinamismo y gestión integral. ¡Olvidate de problemas!"
                aboutTitle2="Campañas de marketing y posicionamiento eficiente."
                aboutContent2="Posicionamos negocios en internet con campañas actractivas. Descubre nuevos clientes y sus crecimientos."
                aboutTitle3="Diseñamos y desarrollamos apps y webs diferentes."
                aboutContent3="Desde el diseño de producto hasta el desarrollamo end-to-end. Creamos tu proyecto de principio a fin."
                aboutTitle4="Conoce fullcommerce y las ventajas para tu marca."
                aboutContent4="Gestionamos tu marca en los principales marketplaces. Escala tu negocio sin preocuparte de nada."
            />
            <Ready/>
            
        </div>
    )
}

export default Home
